module.exports = __webpack_public_path__ + "img/cacao_1600.e60ce960.jpg";